import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { Button } from '@/components/ui/button';
import { isOldVersionError, reloadForUpdate } from '@/lib/app-update';
import { AuthLayout } from './auth-layout';

/**
 * Any page that fails to show: a plain page with a way out, never a raw error. After a deploy
 * (the page's files are from the old version) it loads the new version by itself, once.
 */
export function RouteErrorPage() {
  const error = useRouteError();
  const oldVersion = isOldVersionError(error);
  useEffect(() => {
    if (oldVersion) reloadForUpdate();
    else console.error(error);
  }, [error, oldVersion]);
  return (
    <AuthLayout
      title={oldVersion ? 'Tekansa Connect was updated' : 'Something went wrong'}
      description={
        oldVersion
          ? 'A new version is out. Reload the page to continue.'
          : 'This page could not be shown. Reload it, or go back to Home.'
      }
    >
      <div className="grid gap-3">
        <Button size="lg" className="w-full" onClick={() => window.location.reload()}>
          Reload
        </Button>
        <Button variant="outline" size="lg" className="w-full" asChild>
          <a href="/home">Go to Home</a>
        </Button>
      </div>
    </AuthLayout>
  );
}
